import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import { IThankYouPage } from 'interfaces/IThankYouPage';
import { SvgIcon } from 'components/SvgIcon';
import BoletoCod from '../BoletoCod/index';
import ModalDoubts from '../../ModalDoubts/';
import Translate from 'components/Translate';
import BoletoDownload from '../BoletoDownload';
import { getCdnImage } from 'functions';

const styles = require('./boletoDefault.css');

interface IProps {
  infos: IThankYouPage;
}

export default class BoletoDefault extends BaseComponent<any, IProps>{

  constructor(props: any) {
    super(props);
  }

  render() {

    if (!this.props) {
      return <div />;
    }

    return (
      <div className={styles.component}>
        <div className={'chk-content'}>
          <div className={'chk-svg'}>
            <div>
              <div className={'chk-product-img'}>
                <img src={getCdnImage(this.props.infos.imgProduct)} />
              </div>
              <div className={'chk-svg-check'}>
                <SvgIcon name={'check'} />
              </div>
            </div>
            <div className={'chk-thk theme-label'} id='thankyou-title'>
              {this.props.infos.isFree ?
                <Translate term='Sucesso! Verifique seu e-mail!' />
                : <Translate term='Obrigado pela Compra!' />
              }
            </div>
          </div>
          <div className={'chk-info theme-label'} id='thankyou-text'>
            <Translate term={'Enviamos instruções para acessar seu Conteúdo no email '} />
            <span className='chk-email'>{this.props.infos.userEmail || 'utilizado na compra'}</span>
            <Translate term={'. Se não encontrar nos próximos minutos, verifique também sua caixa de Lixo Eletrônico.'} />
          </div>
          <div className={'chk-boleto-cod'}>
            <BoletoCod isButton={false} cod={this.props.infos.bankslipCode} />
          </div>
          <BoletoDownload nameButton={'Baixar Boleto'} bankslipUrl={this.props.infos.bankslipUrl} />
          <div className={'chk-producer-infos'} id='producer-infos'>
            <p>{this.props.infos.producerName}</p>
            <p>{this.props.infos.producerEmail}</p>
          </div>
          <div className={'chk-doubts'}>
            <ModalDoubts name='Dúvidas frequentes' showIcon />
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ThankYouPage/BoletoPage/BoletoDefault/index.tsx